/**
 * Emulate Link Interaction
 *
 * Emulates the browser's link interaction by opening in a new tab if crtl / cmd
 * is pressed while executed.
 *
 * @param href Url to open
 * @param event Keyboard or mouse event
 */
export const emulateLinkInteraction = (href, event) => {
    const isCtrlOrCmdPressed = event.metaKey || event.ctrlKey;
    window.open(href, isCtrlOrCmdPressed ? '_blank' : '_self');
};
